import React, { useEffect } from 'react';
import { Button, Drawer, Form, Input, InputNumber, Select, Space } from 'antd';
import { BaseModel } from '../../../../types';
import { DeliveryLineRecord } from '../../../../types/DeliveryReceipt';

/** Adds or edits one material on the delivery receipt. */
const LineDrawer = ({
  open,
  line,
  products,
  uoms,
  onClose,
  onSave,
}: {
  open: boolean;
  line: DeliveryLineRecord | null;
  products: BaseModel[];
  uoms: BaseModel[];
  onClose: () => void;
  onSave: (v: DeliveryLineRecord) => void;
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({
      product: line?.product?.id,
      description: line?.description,
      quantity: line?.quantity,
      productUom: line?.productUom?.id,
    });
  }, [open, line]);

  return (
    <Drawer
      title={line?.id ? 'Edit Item' : 'Add Item'}
      open={open}
      onClose={onClose}
      footer={
        <Space>
          <Button onClick={onClose}>Cancel</Button>
          <Button type={'primary'} onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      <Form
        form={form}
        layout={'vertical'}
        onFinish={(v) =>
          onSave({
            ...line,
            product: products.find((p) => p.id === v.product),
            description: v.description,
            quantity: v.quantity,
            productUom: uoms.find((u) => u.id === v.productUom),
          })
        }
      >
        {/* Optional: a sample being sent on often has no product record yet,
            which is why it was sourced in the first place. */}
        <Form.Item name={'product'} label={'Product'}>
          <Select
            allowClear
            showSearch
            optionFilterProp={'label'}
            options={products.map((p) => ({ label: p.description, value: p.id }))}
          />
        </Form.Item>
        <Form.Item
          name={'description'}
          label={'Material'}
          rules={[{ required: true, message: 'Please describe what is being delivered' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'quantity'}
          label={'Quantity'}
          rules={[{ required: true, message: 'Please enter the quantity' }]}
        >
          <InputNumber className={'w-full'} min={0} />
        </Form.Item>
        <Form.Item name={'productUom'} label={'Unit'}>
          <Select
            allowClear
            showSearch
            optionFilterProp={'label'}
            options={uoms.map((u) => ({ label: u.description, value: u.id }))}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default LineDrawer;
